import { chatApi } from '@/api'

/**
 * Открывает личный чат с пользователем без создания записи в БД.
 * Есть переписка — открываем её; нет — пустой диалог-черновик (params.draftUser):
 * чат создастся только первым сообщением, см. InChatView.
 * Ошибки бэкенда (запрет на диалог и т.п.) пробрасываются — показывает их вызывающий код.
 */
export const openPrivateChat = async ({ userId, user = {}, accessAlways = false, changePage }) => {
  const targetUserId = Number(userId ?? user?.id)

  const res = await chatApi.findDirectChat({
    user_id: targetUserId,
    ...(accessAlways ? { accessAlways: 1 } : {}),
  })

  // Интерцептор на 4xx/5xx резолвит промис объектом ошибки axios.
  if (res?.response) {
    throw new Error(
      res.response?.data?.error ?? res.response?.data?.message ?? 'Не удалось открыть чат',
    )
  }

  const chatId = res?.data?.id

  if (chatId) {
    changePage?.('inChat', chatId)
    return chatId
  }

  const backendUser = res?.data?.user ?? {}

  changePage?.('inChat', null, 'create', {
    draftUser: {
      id: targetUserId,
      name: backendUser.name ?? user?.name ?? '',
      avatar: backendUser.avatar ?? user?.avatar_path ?? user?.avatar ?? null,
    },
    accessAlways,
  })

  return null
}

export default openPrivateChat
